<template>
    <b-container>
        <b-row>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                    label="Nome *"
                    v-model="contact.name"
                    icon="group"
                    :error="errors.name">
                </inter-input>
            </b-col>
            <b-col cols="8" md="6" class="mb-3">
                <inter-input
                    label="Cognome *"
                    v-model="contact.surname"
                    icon="group"
                    :error="errors.surname">
                </inter-input>
            </b-col>
        </b-row>
        <b-row class="align-items-end">
            <b-col cols="12" md="5" class="mb-3">
                <inter-input
                    label="Email"
                    v-model="contact.email"
                    icon="mail">
                </inter-input>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
                <inter-input
                    label="Telefono"
                    v-model="contact.phone"
                    icon="phone-call"
                    :error="errors.phone">
                </inter-input>
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
                <inter-input
                    label="Data di nascita *"
                    v-model="contact.birth_date"
                    icon="calendar"
                    type="date-autocomplete"
                    :error="errors.birth_date">
                </inter-input>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12" md="6" class="mb-3">
                <inter-select
                    label="Nazione di nascita *"
                    v-model="contact.birth_nation_id"
                    :option-selected="contact.birth_nation_id"
                    :error="errors.birth_nation_id"
                    :options="getNazioni">
                </inter-select>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" class="mb-3" v-if="contact.birth_nation_id === 168">
                <inter-select
                    label="Provincia di nascita"
                    v-model="contact.birth_prov_id"
                    :option-selected="contact.birth_prov_id"
                    :error="errors.birth_prov_id"
                    :options="getProvincie">
                </inter-select>
            </b-col>
            <b-col cols="12" md="6" class="mb-3" v-if="contact.birth_nation_id === 168">
                <inter-select
                    label="Città di nascita *"
                    v-model="contact.birth_place_id"
                    :option-selected="contact.birth_place_id"
                    :error="errors.birth_place_id"
                    asyncFindAction="select/citta">
                </inter-select>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12" md="6" class="mb-3">
                <inter-select
                    label="Nazione di residenza *"
                    v-model="contact.nation_id"
                    :option-selected="contact.nation_id"
                    :error="errors.nation_id"
                    :options="getNazioni">
                </inter-select>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="5" class="mb-3" v-if="contact.nation_id === 168">
                <inter-select
                    label="Provincia di residenza"
                    v-model="contact.prov_id"
                    :option-selected="contact.prov_id"
                    :options="getProvincie"
                    :error="errors.prov_id">
                </inter-select>
            </b-col>
            <b-col cols="12" md="4" class="mb-3" v-if="contact.nation_id === 168">
                <inter-select
                    label="Città di residenza"
                    v-model="contact.place_id"
                    :option-selected="contact.place_id"
                    :error="errors.place_id"
                    asyncFindAction="select/citta">
                </inter-select>
            </b-col>
            <b-col cols="12" md="3" class="mb-3" v-if="contact.nation_id === 168">
                <inter-input
                    label="CAP"
                    v-model="contact.cap"
                    icon="edit"
                    :error="errors.cap">
                </inter-input>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12" class="text-center">
                <b-form-checkbox v-model="contact.enable_marketing" switch>
                    Con la compilazione dei campi del presente portale si certifica di aver raccolto idonea autorizzazione da parte dell'interessato dei cui dati personali si dispone per la trasmissione di detti dati a F.C. Internazionale Milano S.p.A., ai fini dell'intestazione di titoli di accesso allo stadio G. Meazza di Milano. Alla stessa maniera, si certifica di aver messo a disposizione dell'interessato idonea <a href="https://static.inter.it/aas/link?id=1117" target="_blank">informativa privacy</a>, come elaborata da F.C. Internazionale Milano S.p.A.
                </b-form-checkbox>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import InterInput from "../../../components/form/inter-input/InterInput";
    import Contact from '@/models/Contact';
    import _ from "lodash";
    import {mapGetters} from 'vuex';
    import InterSelect from "../../../components/form/inter-select/InterSelect";

    export default {
        name: "SocietyContactForm",
        components: {InterSelect, InterInput},
        data() {
            return {
                errors: {},
            }
        },
        props: {
            contact: {
                type: Object,
                default: () => Object.assign({}, Contact)
            },
        },
        computed: {
            ...mapGetters([
                'getProvincie',
                'getNazioni'
            ]),
        },

        methods: {

            validate: function () {
                this.errors = {};

                if (this.contact.name === '') {
                    this.errors.name = true;
                }

                if (this.contact.surname === '') {
                    this.errors.surname = true;
                }

                if (this.contact.birth_date === '') {
                    this.errors.birth_date = true;
                }
                var anno=this.contact.birth_date.split("/");
                if (anno[2] < 1930 || anno[2] > 2021) {
                    this.errors.birth_date = true;
                }

                if (!this.contact.birth_nation_id) {
                    this.errors.birth_nation_id = true;
                }

                if (this.contact.birth_nation_id === 168 && !this.contact.birth_prov_id) {
                    this.errors.birth_prov_id = true;
                }

                if (this.contact.birth_nation_id === 168 && !this.contact.birth_place_id) {
                    this.errors.birth_place_id = true;
                }

                if (!this.contact.nation_id) {
                    this.errors.nation_id = true;
                }

                if (this.contact.nation_id === 168 && !this.contact.prov_id) {
                    this.errors.prov_id = true;
                }

                if (this.contact.nation_id === 168 && !this.contact.place_id) {
                    this.errors.place_id = true;
                }

                if (!this.contact.enable_marketing) {
                    this.$bvToast.toast('Devi autorizzare il trattamento dei dati personali', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    this.errors.enable_marketing = true;
                }

                if (this.errors.birth_date) {
                    this.$bvToast.toast('La data di nascita non è corretta.', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    this.errors.enable_marketing = true;
                }

                if (_.isEmpty(this.errors)) {
                    return true;
                } else {
                    this.$bvToast.toast('Mi manca qualche dato', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
